// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ion-card ion-icon.has-equipment {
  float: right;
  font-size: 20px;
}
ion-card ion-card-title, ion-card ion-card-subtitle, ion-card p {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer-address-card/customer-address-card.component.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/components/customer-address-card/customer-address-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;ACCJ;;ADEI;EACI,YAAA;EACA,eAAA;ACCR;ADEI;EACI,YAAA;ACAR","sourcesContent":[":host {\r\n    width: 100%;\r\n}\r\nion-card {\r\n    ion-icon.has-equipment {\r\n        float: right;\r\n        font-size: 20px;\r\n    }\r\n\r\n    ion-card-title, ion-card-subtitle, p {\r\n        color: black;\r\n    }\r\n}",":host {\n  width: 100%;\n}\n\nion-card ion-icon.has-equipment {\n  float: right;\n  font-size: 20px;\n}\nion-card ion-card-title, ion-card ion-card-subtitle, ion-card p {\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
